import CustomeSelectComponent from '../common/CustomeSelectComponent'

export default function LeaseDropdown({leaseCoordenates, handleSelectCoordenate, selectSearchValue}) {
    return (
        <div style={{ 'display': 'flex', "marginLeft": "10px" }}>
            <div style={{ 'width': '80%'}}>
                <CustomeSelectComponent
                    coordenates={leaseCoordenates}
                    handleSelectCoordenate={handleSelectCoordenate}
                    selectedValueUp={selectSearchValue}
                    placeHolder="Select a lease"
                />
            </div>
        </div>
    )
} 